import { render, staticRenderFns } from "./questionList.vue?vue&type=template&id=e10b8a7c&scoped=true"
import script from "./questionList.vue?vue&type=script&lang=js"
export * from "./questionList.vue?vue&type=script&lang=js"
import style0 from "./questionList.vue?vue&type=style&index=0&id=e10b8a7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10b8a7c",
  null
  
)

export default component.exports